var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.focusingField === 'project')?_c('div',{staticClass:"tableSection sectionRecommended"},[_c('button',{class:{
			projectFieldButton: true,
			userSelectedProject: _vm.userChoiceOfProjectName === 'All'
		},on:{"click":function($event){return _vm.userChooseAProject({ Name: 'All' }, $event)}}},[_vm._v(" All Projects ")]),_vm._l((_vm.projects),function(project,projectKey){return _c('button',{key:projectKey,class:{
			projectFieldButton: true,
			userSelectedProject: _vm.userChoiceOfProjectName === project.Name
		},attrs:{"index":projectKey},on:{"click":function($event){return _vm.userChooseAProject(project, $event)}}},[_vm._v(" "+_vm._s(project.Name)+" ")])})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }